import React from "react";
import CustomModal from "../../common/CustomModal";
import { Button } from "../../ui/button";

const DeleteConfirmModal = ({ open, onClose, count, onConfirm, isLoading }) => {
  return (
    <CustomModal open={open} title="Delete ad requests" onClose={onClose} isButtonsRequired={false}>
      <div className="space-y-4 py-2">
        <p className="text-sm">
          <span className="font-medium">{count}</span> ad request{count !== 1 ? "s" : ""} will be deleted. This cannot be undone.
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default DeleteConfirmModal;
